import React, {
  createContext,
  useContext,
  useState,
  useMemo,
  useEffect,
  ReactNode,
} from "react";
import PropTypes from "prop-types";
import { useAppServices } from "hook/services";
import GlobalLoader from "Common/Components/Loader";

interface UserContextType {
  user: Record<string, any>;
  Update: (updates: Record<string, any>) => void;
  clear: () => void;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

UserContext.displayName = "UserContext";

interface UserProviderProps {
  children: ReactNode;
}

function UserProvider({ children }: UserProviderProps) {
  const Service = useAppServices();
  const [user, setUser] = useState<Record<string, any>>({}); // Current logged-in user
  const [loader, setLoader] = useState(true);

  const Update = (updates: Record<string, any>) =>
    setUser((prevUser) => ({ ...prevUser, ...updates }));

  const clear = () => {
    setUser({});
  };

  const value = useMemo(
    () => ({
      user,
      Update,
      clear,
    }),
    [user, Update, clear]
  );

  const getUser = async (localUser: any) => {
    const token = localStorage.getItem("token");
    const { response } = await Service.user.get({
      query: `_id=${localUser._id}`,
      token,
    });
    if (response){

      setUser({ ...response.data, token });
      localStorage.setItem("user", JSON.stringify({ ...response.data, token }));

    }
  };

  const updateUser = async () => {
    let localUser: any = localStorage.getItem("user");
    if (localUser) {
      localUser = JSON.parse(localUser);
    }
    const token = localStorage.getItem("token");
    if (!localUser) return setLoader(false);
    setUser({ ...localUser, token });
    await getUser(localUser);
    return setLoader(false);
  };
  let pageLoad = true;
  const onLoad = () => {
    if (pageLoad) {
      updateUser();
      pageLoad = false;
    }
  };

  useEffect(onLoad, []);

  return loader ? (
 <GlobalLoader/>
  ) : (
    <UserContext.Provider value={value}>{children}</UserContext.Provider>
  );
}

function useUserInfo() {
  const [tempuser, setTempUser] = useState<Record<string, any>>({}); // Current logged-in user
  const context = useContext(UserContext) || tempuser;
  if (!context) {
    throw new Error("useUserInfo must be used within a UserProvider");
  }
  return context;
}

UserProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { UserProvider, useUserInfo };
